import { useEffect, useCallback } from 'react';

/**
 * Registers Ctrl+Enter / Cmd+Enter to trigger a save callback.
 * Attach to form containers so users don't have to click Save.
 */
export function useKeyboardSave(onSave: () => void, enabled = true) {
    const handler = useCallback(
        (e: KeyboardEvent) => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'Enter' && enabled) {
                e.preventDefault();
                onSave();
            }
        },
        [onSave, enabled],
    );

    useEffect(() => {
        document.addEventListener('keydown', handler);
        return () => document.removeEventListener('keydown', handler);
    }, [handler]);
}
